export const reduxConstants = {
    SET_DATA: 'SET_DATA',
    GET_DATA: 'GET_DATA',
}
